import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FIREBASE_APP_CHECK } from '@bhindle/shared/firebase';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NavProgressComponent } from './nav-progress.component';
import { APP_ANALYTICS } from '@bhindle/shared/analytics';
import { LastRouteService } from 'tadone/core';

import { filter } from 'rxjs';

@Component({
  selector: 'bd-shell',
  imports: [NavProgressComponent, RouterOutlet],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ShellComponent {
  #router = inject(Router);
  #appCheck = inject(FIREBASE_APP_CHECK);
  #analytics = inject(APP_ANALYTICS);
  // Activate last-route tracking so the PWA can resume where it left off on cold launch.
  #lastRoute = inject(LastRouteService);

  constructor() {
    this.#router.events
      .pipe(
        takeUntilDestroyed(),
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      )
      .subscribe((event) => {
        const url = event.urlAfterRedirects;
        const segments = url.split('/').filter(Boolean);
        const firstSegment = segments[0] || 'home';
        const secondSegment = segments[1] || undefined;
        this.#analytics.trackPageView(firstSegment);
        if (secondSegment) {
          this.#analytics.trackSectionChange(secondSegment);
        }
        const query: Record<string, string> = {};
        new URLSearchParams(event.url.split('?')[1] || '').forEach((value, key) => {
          query[key] = value;
        });
        this.#analytics.trackRouteChange(url, query);
      });
  }
}
